import React, { Component } from 'react';
import AccountService from '../../../Service/AccountService';

export default class TrasferFunds extends Component {
    constructor(props) {
        super(props);
        this.state = {
            _isLoading: false
        };
    }

    transferFunds = async () => {
        this.setState({ _isLoading: true });
        await AccountService.tranferFundsToOrginator(this.props.customer_id);
        await this.props.reloadBalance();
        this.setState({ _isLoading: false });
    }

    render() {
        return (
            <div
                className="form-group row"
                style={{ marginTop: '25px' }}
            >
                <div className="col-sm-4">
                    Balance ₱{this.props.balance}
                </div>
                <div className="col-sm-8">
                    <button
                        className="btn btn-block btn-primary"
                        disabled={(this.props.balance === '0.00' || this.props.customer_id === null)}
                        onClick={this.transferFunds}
                        style={{ float: 'right' }}
                        type="button"
                    >
                        {this.state._isLoading ? 'Loading...' : 'Tranfer Funds To Originator'}
                    </button>
                </div>
            </div>
        );
    }
}
